export const FILTER_SAVED = 'floorPlan/filter_saved';
